export default __webpack_public_path__ + "static/eks-prometheus-metrics-be7ce0b247b95b665a7597a430104e65.png";